export const commonTaxPayoutDetailsInfo: string = $localize`* according to Polish regulations, a 12% stake tax will be charged and in the case of winnings above PLN 2279.99 a 10% tax on winnings will be charged`;
